import { Stack } from '@fluentui/react/lib/Stack';
import { FontWeights } from '@fluentui/react/lib/Styling';
import React from 'react';
import { defineMessages } from 'react-intl';
import { ExpandableCard } from 'src/core/components/ExpandableCard';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { QuestionCard } from 'src/languageStudio/appShell/prebuiltDemos/generateQuestionsDemo/QuestionCard';
import { expandableCardStyles } from 'src/languageStudio/appShell/prebuiltDemos/utils/commonStyles';

export type AnswerCardProps = {
    answerIndex: number;
    questions: string[];
    confidenceScore: number[];
    answer: string;
};

const messages = defineMessages({
    answer: { id: 'languageStudio.answerCard.sentence', defaultMessage: `Answer {answerNumber}: {answerValue}` }
});

export const AnswerCard = (props: AnswerCardProps) => {
    const { answerIndex, questions, confidenceScore, answer } = props;
    const { localize } = useLocalization();

    const [isCardExpanded, setIsCardExpanded] = React.useState(answerIndex === 0);
    const cardTitle = localize(messages.answer, { answerNumber: answerIndex + 1, answerValue: answer });

    const renderedQuestions: JSX.Element[] = [];

    questions.map((question: string, index: number) => {
        renderedQuestions.push(<QuestionCard question={question} confidenceScore={confidenceScore[index]} questionIndex={index} />);
    });

    return (
        <ExpandableCard
            id={`${answerIndex}`}
            isSeparatorDisplayed={false}
            isExpanded={isCardExpanded}
            isTruncatedText={!isCardExpanded}
            onExpansionChange={setIsCardExpanded}
            styles={expandableCardStyles(!isCardExpanded, FontWeights.semibold)}
            title={cardTitle}>
            <Stack horizontal wrap verticalAlign="start" tokens={{ childrenGap: 20 }}>
                {renderedQuestions}
            </Stack>
        </ExpandableCard>
    );
};
